import { ResumeUpdateRequest } from '../../catalog/item/resumeUpdate.request';

export class ClientResumeUpdateRequest extends ResumeUpdateRequest {}
